// extracted by mini-css-extract-plugin
module.exports = {"right":"Carousel_right__2MwVe","left":"Carousel_left__3ZcGB"};